/**
 * Authentication Context Definition
 */

import { createContext } from 'react';
import type { AuthUser } from '@/services/auth';
import type { UserProfile } from '@/types/profile.types';
import type { Session } from '@supabase/supabase-js';

export interface AuthContextValue {
  user: AuthUser | null;
  session: Session | null;
  profile: UserProfile | null;
  isLoading: boolean;
  isConfigured: boolean;
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
